<ul class="flex flex-col gap-1">
  @for (item of navigationItems(); track item.label) {
    @let expanded = expandedLabels().has(item.label) || item.expanded === true;
    <li>
      @if (hasChildren(item)) {
        <button
          type="button"
          [ngClass]="getInnerClasses(item)"
          class="nav-item-btn touch-manipulation select-none"
          [attr.aria-expanded]="expanded"
          (click)="toggleExpandItem(item, $event)"
        >
          <span class="flex min-w-0 flex-1 items-center gap-2">
            @if (item.icon) {
              <i
                [class]="item.icon"
                class="h-4 w-4 shrink-0 text-base leading-none"
              ></i>
            }
            <span class="truncate">{{ item.label }}</span>
          </span>
          <i
            class="ri-arrow-down-s-line h-4 w-4 shrink-0 transition-transform duration-200"
            [class.rotate-180]="expanded"
            aria-hidden="true"
          ></i>
        </button>
        @if (expanded) {
          <ul
            class="mx-3.5 flex min-w-0 translate-x-px flex-col gap-1 border-l border-sidebar-border px-2.5 py-0.5"
          >
            @for (child of item.children; track child.label) {
              <li>
                @if (child.route) {
                  <button
                    type="button"
                    [ngClass]="getChildClasses(child)"
                    class="nav-item-btn touch-manipulation"
                    (click)="navigateToItem(child)"
                  >
                    @if (child.icon) {
                      <i
                        [class]="child.icon"
                        class="h-4 w-4 shrink-0 text-base leading-none"
                      ></i>
                    }
                    <span class="truncate">{{ child.label }}</span>
                  </button>
                } @else if (child.url) {
                  <a
                    [href]="child.url"
                    [ngClass]="getChildClasses(child)"
                    class="nav-item-btn no-underline touch-manipulation"
                    [target]="child.url.startsWith('http') ? '_blank' : '_self'"
                    (click)="onExternalLink()"
                  >
                    @if (child.icon) {
                      <i
                        [class]="child.icon"
                        class="h-4 w-4 shrink-0 text-base leading-none"
                      ></i>
                    }
                    <span class="truncate">{{ child.label }}</span>
                  </a>
                }
              </li>
            }
          </ul>
        }
      } @else if (item.route) {
        <button
          type="button"
          [ngClass]="getInnerClasses(item)"
          class="nav-item-btn touch-manipulation"
          (click)="navigateToItem(item)"
        >
          @if (item.icon) {
            <i
              [class]="item.icon"
              class="h-4 w-4 shrink-0 text-base leading-none"
            ></i>
          }
          <span class="truncate">{{ item.label }}</span>
        </button>
      } @else if (item.url) {
        <a
          [href]="item.url"
          [ngClass]="getInnerClasses(item)"
          class="nav-item-btn no-underline touch-manipulation"
          [target]="item.url.startsWith('http') ? '_blank' : '_self'"
          (click)="onExternalLink()"
        >
          @if (item.icon) {
            <i
              [class]="item.icon"
              class="h-4 w-4 shrink-0 text-base leading-none"
            ></i>
          }
          <span class="truncate">{{ item.label }}</span>
        </a>
      }
    </li>
  }
</ul>
